import { ADMIN_TYPE } from "@/enum";

export default [
  {
    path: "/operator-requests",
    meta: {
      requiresAuth: true,
      permission: null,
      title: "Operadores",
      layout: "admin",
      module: "operators",
      icon: "mdi-account",
      notBreadCrumb: true,
      roles: [ADMIN_TYPE.RIDERY]
    },
    component: () =>
      import(
        /* webpackChunkName: "OperatorsLayout" */ "@/views/operators-request/OperatorRequestsLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "operator-requests-list",
        meta: {
          requiresAuth: true,
          permission: null,
          layout: "admin",
          module: "operators",
          title: "Solicitudes",
          adminLayoutNav: true,
          icon: "mdi-format-list-bulleted",
          notBreadCrumb: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "OperatorRequestsList" */ "@/views/operators-request/OperatorRequestsList.vue"
          ),
      },
      {
        path: "list",
        name: "operators-list",
        meta: {
          requiresAuth: true,
          permission: null,
          layout: "admin",
          module: "operators",
          title: "Listado",
          adminLayoutNav: true,
          icon: "mdi-format-list-bulleted",
          notBreadCrumb: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "OperatorsList" */ "@/views/operators-request/OperatorsList.vue"
          ),
      },
    ],
  },
];
